/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Newpatient_Welcome1Inputs */

const en_newpatient_welcome1 = /** @type {(inputs: Newpatient_Welcome1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Welcome, ${i?.name}`)
};

const fr_newpatient_welcome1 = /** @type {(inputs: Newpatient_Welcome1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bienvenue, ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Welcome, {name}" |
*
* @param {Newpatient_Welcome1Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
const newpatient_welcome1 = /** @type {((inputs: Newpatient_Welcome1Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newpatient_Welcome1Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_newpatient_welcome1(inputs)
	return fr_newpatient_welcome1(inputs)
});
export { newpatient_welcome1 as "newPatient_welcome" }